import { CustomerModel, CustomerTypeEnum } from 'api-hooks/customer';
import * as Yup from 'yup';

export const CustomerSystemFormSchema = () =>
  Yup.object({
    duePeriod: Yup.number().default(0),
    isTransactionLimited: Yup.boolean().default(false),
    transactionLimit: Yup.number().default(0),
    remainingTransactionQuota: Yup.number().default(0),
  });

export const CustomerBillingFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    name: Yup.string().default(''),
    phone: Yup.string().default(''),
    phone_2: Yup.string().default(''),
    address: Yup.string().default(''),
    bank: Yup.string().default(''),
    accountNumber: Yup.string().default(''),

    //additional information
    customId: Yup.string().default(''),
  });

export const CustomerFormSchema = () =>
  Yup.object({
    address: Yup.string().default(''),
    balance: Yup.number().transform((value) =>
      isNaN(value) ? undefined : value,
    ),
    name: Yup.string().default(''),
    alias: Yup.string().default(''),
    phone: Yup.string().default(''),
    phone_2: Yup.string().default(''),
    email: Yup.string().email().default(''),
    title: Yup.string().nullable().default(null),
    religion: Yup.string().default(''),
    system: CustomerSystemFormSchema(),
    type: Yup.string().default(CustomerTypeEnum.individual),
    description: Yup.string().default(''),
    billings: Yup.array(CustomerBillingFormSchema()).default([]),
  });

export type CustomerFormType = Yup.InferType<
  ReturnType<typeof CustomerFormSchema>
> & {
  data?: CustomerModel;
};

export type CustomerBillingFormType = Yup.InferType<
  ReturnType<typeof CustomerBillingFormSchema>
>;

export type CustomerSystemFormType = Yup.InferType<
  ReturnType<typeof CustomerSystemFormSchema>
>;
